import { Component } from '@angular/core';
import { AbstractComponent } from '../abstract-component';
import {Timestamp} from '../timestamp/Timestamp';

@Component({
    selector: 'app-footer',
    imports: [],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.css'
})
export class FooterComponent extends AbstractComponent{
  timestamp: string;
  constructor() {
    super();
    this.timestamp = Timestamp.stamp;
  }
}
